export function StateMachineLegend() {
  const items = [
    ["Deterministic FSM Transition", "currentColor", undefined],
    ["Agent LLM Output Flow", "var(--ga-diagram-agent)", "4 2"],
    ["Bounded Repair Cycle", "var(--ga-diagram-repair)", undefined],
    ["Circuit-Breaker Fallback", "var(--ga-diagram-danger)", "4 2"],
  ] as const;

  return (
    <g transform="translate(35, 345)">
      <rect
        width="250"
        height="120"
        rx="6"
        fill="var(--ga-paper-strong)"
        stroke="var(--ga-line)"
        strokeWidth="1"
      />
      <text
        x="14"
        y="20"
        className="text-[10px] font-mono font-bold tracking-wider uppercase"
        fill="var(--ga-text-muted)"
      >
        DIAGRAM NOTATION KEY
      </text>
      {items.map(([label, stroke, dash], index) => {
        const y = 40 + index * 20;
        return (
          <g key={label}>
            <line
              x1="14"
              y1={y}
              x2="40"
              y2={y}
              stroke={stroke}
              strokeWidth="1.8"
              strokeDasharray={dash}
              opacity={index === 0 ? 0.6 : undefined}
            />
            <text
              x="50"
              y={y + 3}
              className="text-[10px] font-mono"
              fill={stroke}
            >
              {label}
            </text>
          </g>
        );
      })}
    </g>
  );
}
